'use strict';

var GroupSeriesTelnet = require('./GroupSeriesTelnet');

function Hdx(ipAddress, username, password, onConnectStatus, onControlStatus, config) {
	GroupSeriesTelnet.call(this, ipAddress, username, password, onConnectStatus,
		onControlStatus, config);
}

Hdx.prototype = Object.create(GroupSeriesTelnet.prototype);
Hdx.prototype.constructor = Hdx;

Hdx.prototype.name = 'HDX';
Hdx.prototype.key = '-KD9NDpn5_Fbavz8kPZY';
Hdx.prototype.simulationParams.firmwareVersion = '3.1.11';
Hdx.prototype.cameraLimits = {
	x: { min: -880, max: 880},
	y: { min: -300, max: 300 },
	z: { min: 0, max: 1023 },
};
Hdx.prototype.ports = [{
    port: 24, // default control port
    verifySend: null,
    verifyConnection: /Hi, my name is|Welcome to Polycom|Welcome* to ViewStation/,
    verifyTimeoutMs: 1000,
    loginSkip: /Here is what I know about myself/,
    passwordPrompt: /Password:/,
    passwordPromptTimeoutMs: 1000,
    passwordDefault: null,
    passwordSend: function(value) { return value; },
    loginVerify: /Hi, my name is/,
    loginReject: /password failed/,
    loginVerifyTimeoutMs: 1000
}, {
    port: 23, // optional control port
    verifySend: null,
    verifyConnection: /Hi, my name is|Welcome to Polycom|Welcome* to ViewStation/,
    verifyTimeoutMs: 1000,
    loginSkip: /Here is what I know about myself/,
    passwordPrompt: /Password:/,
    passwordPromptTimeoutMs: 1000,
    passwordDefault: null,
    passwordSend: function(value) { return value; },
    loginVerify: /Hi, my name is/,
    loginReject: /password failed/,
    loginVerifyTimeoutMs: 1000
}, {
    port: 4999, // Global Cache Ethernet to RS-232 bridge
    verifySend: '\n\nexit\n\nwhoami\n',
    verifyConnection: /Hi, my name is|Welcome to Polycom|Welcome* to ViewStation|login failed, retry/,
    verifyTimeoutMs: 1000,
    loginSkip: /Here is what I know about myself/,
    passwordPrompt: /Password:/,
    passwordPromptTimeoutMs: 1000,
    passwordDefault: null,
    passwordSend: function(value) { return value; },
    loginVerify: /Hi, my name is/,
    loginReject: /password failed/,
    loginVerifyTimeoutMs: 1000
}];

module.exports = Hdx;
